"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var InputField_1 = __importDefault(require("../Fields/InputField"));
var validation_1 = require("../../utils/validation");
var Context_1 = require("../Context");
function PhoneNumberField(props, ref) {
    var _a = props.name, name = _a === void 0 ? 'phoneNumber' : _a, validate = props.validate, rest = __rest(props, ["name", "validate"]);
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var isUS = i18n.language === 'en';
    var setFieldValue = (0, Context_1.useFormContext)().setFieldValue;
    var validateUSPhoneNumber = function (value) {
        if (!(0, validation_1.isUSPhone)(value.trim())) {
            return t('Please enter a valid US phone number');
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    var validateCNPhoneNumber = function (value) {
        if (!(0, validation_1.isCNPhone)(value.trim())) {
            return t('Please enter a valid CN phone number');
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    var handleUSChange = function (event) {
        var value = event.target.value;
        // always prefix with +1
        if (!value.startsWith('+1')) {
            // when + is deleted
            if (value.startsWith('1')) {
                setFieldValue(name, '+' + value);
                // when 1 is deleted
            }
            else if (value.startsWith('+')) {
                setFieldValue(name, '+1' + value.replace('+', ''));
            }
            else {
                setFieldValue(name, '+1' + value);
            }
        }
        // when backspace is pressed
        if (value === '+') {
            setFieldValue(name, '+1');
        }
    };
    var handleCNChange = function (event) {
        var value = event.target.value;
        // always prefix with +86
        if (!value.startsWith('+86')) {
            if (value.startsWith('86')) {
                setFieldValue(name, '+' + value);
            }
            else if (value.startsWith('8')) {
                setFieldValue(name, '+86' + value.replace('8', ''));
            }
            else if (value.startsWith('6')) {
                setFieldValue(name, '+86' + value.replace('6', ''));
            }
            else if (value.startsWith('+6')) {
                setFieldValue(name, '+86' + value.replace('+6', ''));
            }
            else if (value.startsWith('+8')) {
                setFieldValue(name, '+86' + value.replace('+8', ''));
            }
            else {
                setFieldValue(name, '+86' + value);
            }
        }
        // when backspace is pressed
        if (value === '+8') {
            setFieldValue(name, '+86');
        }
    };
    var handleValidation;
    var maxLength;
    var handleChange;
    if (isUS) {
        handleValidation = validateUSPhoneNumber;
        // +18181112222 => 12 characters
        maxLength = 12;
        handleChange = handleUSChange;
    }
    else {
        handleValidation = validateCNPhoneNumber;
        maxLength = 13;
        handleChange = handleCNChange;
    }
    return (react_1.default.createElement(InputField_1.default, __assign({ ref: ref, name: name, label: t('Phone Number'), placeholder: t('Phone Number'), numeric: true, validate: handleValidation, maxLength: maxLength, type: 'tel', inputMode: 'tel', autoComplete: 'tel', onChange: handleChange }, rest)));
}
exports.default = react_1.default.forwardRef(PhoneNumberField);
